<app-company-base (companyAvailable)="companyAvailableHandler($event)"
    [useContainer]="false"
    >
    <div>
        <div>
            <h1 class="mat-headline-1">{{title}}</h1>
        </div>

        @if(phase1){
            <ng-content select="import-intro"></ng-content>
            
            <div fxLayout="row" fxLayoutGap="10px">
                <div fxFlex="50">
                    <div class="dropzone" appFileDragDropDirective
                            [extensions]="extensions"
                            [types]="types"
                            (dropReceived)="uploadFile($event)">
                        <div class="text-wrapper">
                            <div class="centered">
                                <h1 class="mat-headline-4" style="text-align:center">
                                    Drop here!
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div fxFlex="50">
                    <h1 class="mat-headline-1" style="text-align:center">
                        Or browse and select file
                    </h1>
                    <p style="text-align:center">
                        <button type="button" mat-raised-button color="accent" (click)="fileInput.click()">Choose file</button>
                        <input hidden type="file" #fileInput id="file" (change)="onFileSelected()" />
                    </p>
                </div>
            </div>
              
              
          
            <p *ngIf="error" style="padding: 25px; font-weight: bold; color: red;">
                Whoops.  It looks like something went wrong while trying to upload your data file. 
                <span *ngIf="errorMessage"><br/>The error message was: "{{errorMessage}}"</span>
            </p>
        }
        @else{
            <ng-content></ng-content>
        }
    </div>
</app-company-base>